import React from 'react';

export interface OrbitPromptProps {
  /** "§A · Company · 1 / 4" style mono caption */
  eyebrow: string;
  /** Prompt text — pass JSX to include <em>italic serif accents</em> */
  children: React.ReactNode;
}

/**
 * Orbit's avatar + eyebrow + prompt. The `em` element rendered inside
 * `children` automatically becomes IBM Plex Serif italic per the scoped
 * orbit-tokens.css. Use sparingly — italic accents are editorial lift.
 */
export function OrbitPrompt({ eyebrow, children }: OrbitPromptProps) {
  return (
    <div className="aa-orbit-prompt">
      <div className="aa-orbit-avatar" aria-hidden="true">
        <img src="/orbit/logos/aa-logo-icon.svg" alt="" />
      </div>
      <div className="aa-prompt-body">
        <div className="aa-eyebrow" style={{ marginBottom: '8px' }}>
          {eyebrow}
        </div>
        <h2 className="aa-prompt-text">{children}</h2>
      </div>
    </div>
  );
}

export default OrbitPrompt;
